import { useState } from "react";

export default function useReferralOptions() {
    const [referralSource] = useState([
        { value: "COMPR", label: "Comparative Rater" },
        { value: "WEBASSOC", label: "GEICO Website or Associate" },
        { value: "PRTNR", label: "Industry Partners" },
        { value: "INTERNET", label: "Internet Search" },
        { value: "TRADESHOW", label: "Trade Show" },
        { value: "WORDMOUTH", label: "Word of Mouth" },
        { value: "OTHER", label: "Other" }
    ]);

    return referralSource;
}